<h3 mat-dialog-title>
    {{ dialogTitle }}
    <button mat-icon-button [disableRipple]="true" mat-dialog-close><mat-icon>close</mat-icon></button>
</h3>

<mat-dialog-content>
    <!-- Verify mode: all capabilities restricted -->
    <ng-container *ngIf="mode === modes.VERIFY">
        <div class="dialog-icon">
            <div class="icon-circle">
                <mat-icon svgIcon="icon-v2:shield-warning"></mat-icon>
            </div>
        </div>

        <p class="dialog-description">
            {{ 'To protect your community from fraud, PayHOA verifies new accounts before enabling payment features. This usually happens automatically when your first payment is processed — no action needed on your end.' }}
        </p>

        <div class="capability-section">
            <div class="capability-item">
                <mat-icon svgIcon="icon-v2:arrow-upright" class="capability-icon"></mat-icon>
                <div class="capability-text">
                    <strong>{{ 'External Payouts & Spend Cards' }}</strong>
                    <span>{{ 'Pay vendors, issue refunds, outbound transfers, and issue virtual/physical cards' }}</span>
                </div>
            </div>
            <div class="capability-item">
                <mat-icon svgIcon="icon-v2:arrow-down" class="capability-icon"></mat-icon>
                <div class="capability-text">
                    <strong>{{ 'Fund Deposits' }}</strong>
                    <span>{{ 'Pull funds from connected bank accounts into your Treasury Balance' }}</span>
                </div>
            </div>
        </div>

        <app-alert-block type="info">
            <strong>{{ 'Haven\'t had a payment yet?' }}</strong>
            {{ 'You can manually request early verification and our team typically approves within 24–48 hours.' }}
        </app-alert-block>
    </ng-container>

    <!-- Request specific capability mode -->
    <ng-container *ngIf="mode === modes.REQUEST_CAPABILITY">
        <div class="dialog-icon">
            <div class="icon-circle">
                <mat-icon svgIcon="icon-v2:shield-warning"></mat-icon>
            </div>
        </div>

        <p class="dialog-description">
            {{ 'To protect your community and prevent fraud, PayHOA verifies new accounts before enabling payment features. Submit your request and our team will review it within 24–48 hours.' }}
        </p>

        <div class="capability-section">
            <div class="capability-item" *ngIf="capabilityType === capabilities.FUND_DEPOSITS">
                <mat-icon svgIcon="icon-v2:arrow-down" class="capability-icon"></mat-icon>
                <div class="capability-text">
                    <strong>{{ 'Fund Deposits' }}</strong>
                    <span>{{ 'Pull funds from connected bank accounts into your Treasury Balance' }}</span>
                </div>
            </div>
            <div class="capability-item" *ngIf="capabilityType === capabilities.EXTERNAL_PAYOUTS">
                <mat-icon svgIcon="icon-v2:arrow-upright" class="capability-icon"></mat-icon>
                <div class="capability-text">
                    <strong>{{ 'External Payouts & Spend Cards' }}</strong>
                    <span>{{ 'Pay vendors, issue refunds, outbound transfers, and issue virtual/physical cards' }}</span>
                </div>
            </div>
        </div>

        <app-alert-block type="info">
            <strong>{{ 'Typical review time: 24–48 hours.' }}</strong>
            {{ 'You\'ll receive an email notification when your request is approved or if we need additional information.' }}
        </app-alert-block>
    </ng-container>

    <!-- Submitted mode -->
    <ng-container *ngIf="mode === modes.SUBMITTED">
        <app-empty-state>
            <app-avatar-block [iconOnly]="true" svgIcon="icon-v2:check"></app-avatar-block>
            <span emptyStateTitle>{{ 'Your request is under review' }}</span>
            <span emptyStateText>{{ 'Our team will verify your account and respond within 24–48 hours. You\'ll be notified by email when approved.' }}</span>
        </app-empty-state>
    </ng-container>

    <!-- In-progress mode -->
    <ng-container *ngIf="mode === modes.IN_PROGRESS">
        <app-empty-state>
            <app-avatar-block [iconOnly]="true" svgIcon="icon-v2:hourglass-medium"></app-avatar-block>
            <span emptyStateTitle>{{ 'Your request is under review' }}</span>
            <span emptyStateText>{{ 'Our team is reviewing your account and will respond within 24–48 hours. You\'ll be notified by email when approved.' }}</span>
        </app-empty-state>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
    <ng-container *ngIf="mode === modes.VERIFY">
        <button mat-flat-button [disableRipple]="true" color="accent" mat-dialog-close>{{ 'Maybe Later' }}</button>
        <button-spacer></button-spacer>
        <button mat-flat-button [disableRipple]="true" color="primary"
                [disabled]="isSubmitting"
                (click)="onRequestEarlyVerification()">
            {{ 'Request Early Verification' }}
        </button>
    </ng-container>

    <ng-container *ngIf="mode === modes.REQUEST_CAPABILITY">
        <button mat-flat-button [disableRipple]="true" color="accent" mat-dialog-close>{{ 'Cancel' }}</button>
        <button-spacer></button-spacer>
        <button mat-flat-button [disableRipple]="true" color="primary"
                [disabled]="isSubmitting"
                (click)="onRequestEarlyVerification()">
            {{ 'Submit request' }}
        </button>
    </ng-container>

    <ng-container *ngIf="mode === modes.SUBMITTED || mode === modes.IN_PROGRESS">
        <flex-spacer></flex-spacer>
        <button mat-flat-button [disableRipple]="true" color="primary" mat-dialog-close>{{ 'Got it' }}</button>
    </ng-container>
</mat-dialog-actions>
